import React, { FunctionComponent } from 'react'
import { useLocation, Link } from 'react-router-dom'

interface CarouselInterface {
    prefix: string
    sizes: string[]
    count: number
}

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
}

const Carousel:FunctionComponent<{ gallery: CarouselInterface }> = (props) => {

    const { gallery } = props
    
    let query = useQuery()

    const selectedItemInt = parseInt(query.get("image") || '-1')
  
    const selectedImage = [`${gallery.prefix}${selectedItemInt < 10 ? "0" : ""}${selectedItemInt}${gallery.sizes[0]}`, `${gallery.prefix}${selectedItemInt < 10 ? "0" : ""}${selectedItemInt}${gallery.sizes[window.innerWidth < 400 ? 0 : window.innerWidth < 1300 ? 1 : 2]}`]

    return (<>
      <ul className={"thumbs_gallery"}>
        {
          Array(gallery.count).fill(null).map((_, index) => 
          <li key={index}>
            <Link to={`./?image=${ index }`}>
              <img alt={""} src={`${gallery.prefix}${index < 10 ? "0" : ""}${index}${gallery.sizes[0]}`}/>
            </Link>
          </li>)
        }
      </ul>
      { 
          selectedItemInt >= 0 
          ? 
            <div className={'selectedItem'}>
              <Link to={`./?image=${ (selectedItemInt === 0 ? gallery.count : selectedItemInt) - 1 }`}></Link>
              <Link to={`./`}>
                <div style={{backgroundImage: `url(${selectedImage[1]}), url(${selectedImage[0]})`}}>
                  <img alt={""} src={selectedImage[1]}/>
                </div>
              </Link>
              <Link to={`./?image=${ (selectedItemInt >= gallery.count - 1 ? 0 : selectedItemInt + 1)  }`}></Link>
            </div> 
          : null 
      }
    </>)
}

export default Carousel

